.boost-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 84px;
  padding: var(--alto-sem-space-4xs) var(--alto-sem-space-xs);
  column-gap: var(--alto-sem-space-xs);
  border-radius: var(--alto-sem-radius-xs);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  flex-shrink: 0;
}

.boost-card--selected {
  background: var(--alto-sem-color-bg-accent-subtle-default);
  border: var(--alto-sem-border-width-sm) solid var(--alto-sem-color-border-accent);
}

.boost-card--default {
  background: var(--alto-sem-color-bg-layer1-default);
  border: var(--alto-sem-border-width-sm) solid var(--alto-sem-color-border-tertiary);
}

.boost-card--default:hover {
  border-color: var(--alto-sem-color-border-secondary);
}

.boost-card--disabled {
  background: var(--alto-sem-color-bg-disabled-subtle);
  border: var(--alto-sem-border-width-sm) solid var(--alto-sem-color-border-tertiary);
  cursor: not-allowed;
  pointer-events: none;
}

.boost-card:focus-visible {
  outline: 2px solid var(--alto-sem-color-border-accent);
  outline-offset: 2px;
}

.avios-badge-wrapper--disabled {
  opacity: 0.5;
}

.best-value-badge {
  position: absolute;
  top: -10px;
  right: var(--alto-sem-space-xs);
  z-index: 1;
}

.best-value-badge--disabled {
  background: var(--alto-sem-color-bg-disabled-vibrant) !important;
}
